import * as React from "react";
import { Controller, useForm } from "react-hook-form";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import { login, logoutStatic } from "../../StateManagement/authSlice";
import { useDispatch, useSelector } from "react-redux";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import { useLocation, useNavigate } from "react-router-dom";
import { getProvince } from "../../StateManagement/ProvinceSlice";
import { fetchData } from "../../Cpanel/Components/Utilities";
import AvatarImg from "../../Assets/images/avatar.png";
import { BASE_URL } from "./Api/Api";
import { DropDownFormat } from "./FormOptions/DropDownFormat";
import { InputFormat } from "./FormOptions/InputFormat";
import SweetAlert from "./SweetAlert/SweetAlert";
import TelInput from "./FormOptions/TelInput";
const defaultValues = {
  BirthDay: new Date(),
  CityId: "",
  ProvinceId: "",
  family: "",
  name: "",
  sex: "",
  address: "",
  description: "",
  postalcode: "",
};

export const BuyProductForm = ({ onNext }) => {
  const [avatarSrc, setAvatarSrc] = useState("");
  const [Logo, setLogo] = useState("");

  const [checkLogin, setCheckLogin] = useState("");
  const [cityList, setCityList] = useState([]);
  const [ProvinceList, setProvinceList] = useState([]);
  const province = useSelector((state) => state?.province?.province);
  const location = useLocation();
  const { product } = location.state;
  const {
    handleSubmit,
    watch,
    reset,
    control,
    register,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues });

  useEffect(() => {
    dispatch(getProvince());
    const mapOptions = (apiResponse) => {
      return apiResponse?.map((item) => ({
        value: item.provinceid,
        label: item.provincename,
      }));
    };
    const data = mapOptions(province);
    setProvinceList(data);
  }, []);

  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    fetchData("guid", bodyFormData, handleApiResponse);
  }, []);

  const handleApiResponse = (data) => {
    setCheckLogin(data?.UserId);
    console.log("data user", data);
    setUserLogo(data?.userinfo?.pic);
    // setAvatarSrc(data?.userinfo?.pic);
    reset({
      ...defaultValues,
      ...data?.userinfo,
      BirthDay: new Date(data?.userinfo?.BirthDay) || new Date(),
    });
  };

  useEffect(() => {
    if (checkLogin === "0") {
      dispatch(logoutStatic());
      navigate("/");
    }
  }, [checkLogin]);
  console.log(product);
  const dispatch = useDispatch();
  const [userLogo, setUserLogo] = useState(null);
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    const bodyFormData = new FormData();

    bodyFormData.append("pid", product.id);
    bodyFormData.append("pprice", product.price);
    bodyFormData.append("ptitle", product.title);

    bodyFormData.append("uid", checkLogin);
    bodyFormData.append("uname", data?.name);
    bodyFormData.append("ufamily", data?.family);
    bodyFormData.append("umob", data?.mob);
    bodyFormData.append("uprovince", data?.ProvinceId);
    bodyFormData.append("ucity", data?.CityId);
    bodyFormData.append("uaddress", data?.address);
    bodyFormData.append("upostalcode", data?.postalcode);
    bodyFormData.append("udescription", data?.description);
    fetchData("productpayment", bodyFormData, handleBuyResponse);
  };

  const handleBuyResponse = (data) => {
    console.log("buy response");
    if (data?.code === 1) {
      window.location.href = data?.msg;
    }
  };
  const handleLogout = () => {
    dispatch(logoutStatic());
  };

  useEffect(() => {
    const fetchData = async () => {
      const bodyFormData = new FormData();
      bodyFormData.append("provinceId", watch("ProvinceId"));
      try {
        const response = await axios.post(BASE_URL, bodyFormData, {
          headers: {
            "Content-type": "multipart/form-data",
            Accept: "application/json",
            cmd: "city",
          },
        });
        if (response.status === 200) {
          const data = await response.data;

          return data?.dt;
        } else {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
      } catch (error) {
        throw error;
      }
    };
    if (!watch("ProvinceId")) {
      setCityList([]);
      return;
    }
    fetchData().then((value) => {
      const mapOptions = (apiResponse) => {
        return apiResponse?.map((item) => ({
          value: item.cityid,
          label: item.cityname,
        }));
      };
      const data = mapOptions(value);
      setCityList(data);
      console.log(data);
    });
  }, [watch("ProvinceId")]);

  return (
    <div dir="rtl" className="">
      <div className="card wd-50 wm-100 mx-auto p-3">
        <Form dir="rtl" onSubmit={handleSubmit(onSubmit)}>
          <Row className=" d-flex justify-content-center align-items-center">
            <Col className=" col-12 col-lg-4">
              <div className="col-12 text-center  ">
                <img
                  id="avatar"
                  className="qrcode"
                  onClick={() => document.getElementById("fileInput").click()}
                  alt="برای ارسال عکس کلیک کنید"
                  src={`https://api.taab30.com${product?.pic}`}
                />
              </div>
            </Col>
            <Col className=" col-12 col-lg-4">
              <div>نام کالا</div>
              <div className="product-price">{product?.title}</div>
            </Col>
            <Col className=" col-12 col-lg-4">
              <div>قیمت کالا</div>
              <div className="product-price">
                {product?.price?.toLocaleString("en-US", {
                  style: "decimal",
                  maximumFractionDigits: 0,
                })}
               <span className="fs-6"> تومان</span>
              </div>
            </Col>
          </Row>
          <br />
          <Row>
            <Col className=" col-12 col-lg-4">
              <InputFormat
                control={control}
                name="name"
                type={"text"}
                label="نام"
                errors={errors}
              />
            </Col>
            <Col className=" col-12 col-lg-4">
              <InputFormat
                control={control}
                name="family"
                type={"text"}
                label="نام خانوادگی"
                errors={errors}
              />
            </Col>
            <Col className=" col-12 col-lg-4">
              <InputFormat
                control={control}
                name="mob"
                type={"text"}
                label=" شماره موبایل"
                errors={errors}
              />
            </Col>
          </Row>
          <Row>
            <Row>
              <Col className=" col-12 col-lg-4">
                <DropDownFormat
                  control={control}
                  label={"استان"}
                  options={ProvinceList}
                  errors={errors}
                  name={"ProvinceId"}
                />
              </Col>
              <Col className=" col-12 col-lg-4">
                <DropDownFormat
                  control={control}
                  label={"شهر"}
                  options={cityList}
                  errors={errors}
                  name={"CityId"}
                />
              </Col>
              <Col className=" col-12 col-lg-4">
                <TelInput
                  control={control}
                  label={"کدپستی"}
                  type={"number"}
                  errors={errors}
                  name={"postalcode"}
                  maxLength={10}
                />
              </Col>
            </Row>

            <Col className="col-12 col-lg-12">
              <InputFormat
                control={control}
                type={"textarea"}
                label="آدرس"
                name="address"
              />
            </Col>
            <Col className="col-12 col-lg-12">
              <InputFormat
                control={control}
                type={"textarea"}
                label="توضیحات"
                name="description"
              />
            </Col>
          </Row>

          <Row>
            <Col
              className="px-5 col-12 col-lg-12 d-flex gap-2 align-items-center mt-5"
              dir="ltr"
            >
              <Button variant="success" type="submit" className="btn-sm px-4">
                پرداخت
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};
